export function formatRelativeTime(intlShape, ...[value, unit, formatOptions]) {
  return intlShape.formatRelativeTime(value, unit, formatOptions);
}